import { useState, createContext } from 'react';

export const SidebarContext = createContext({});

export const SidebarProvider = ({ children }) => {
  const [sidebarToggle, setSidebarToggle] = useState(false);
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarToggle(!sidebarToggle);
  };
  const closeSidebar = () => {
    setSidebarToggle(false);
  };
  const toggleDesktopSidebar = () => {
    setDesktopSidebarOpen((open) => !open);
  };

  return (
    <SidebarContext.Provider
      value={{
        sidebarToggle,
        toggleSidebar,
        closeSidebar,
        desktopSidebarOpen,
        toggleDesktopSidebar
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
